import { AgentObjectHeroCard } from "@/pages/agent/components/agent-object-hero-card";
import type { AgentGoal } from "@/pages/agent/intent-graph/agent-intent-graph.types";

export const AgentGoalHeroCard = ({ goal }: { goal: AgentGoal }) => {
  const title = goal.title || "Untitled goal";

  return (
    <AgentObjectHeroCard
      ariaLabel={`Goal: ${title}`}
      description={goal.description}
      status={goal.status}
      title={title}
    />
  );
};
